import { inject } from "@angular/core";
import { ActivatedRouteSnapshot, ResolveFn, Router, RouterStateSnapshot } from "@angular/router";
import { ModalService } from "@core-services/modal.service";
import { CryptoWalletService } from "@main-services/wallet/crypto_wallet.service";
import { CryptoTransaction } from "@models/transaction/crypto_transaction";
import { TransactionWrapperModalComponent } from "./modals/transaction-wrapper-modal/transaction-wrapper-modal.component";
import { InfoService } from "@core-services/info.service";
import { TranslationService } from "@core-services/translation.service";

export const transactionRouteResolverFn: ResolveFn<CryptoTransaction | boolean> = (
	activatedRouteSnapshot: ActivatedRouteSnapshot,
	state: RouterStateSnapshot
) => {
	const cryptoWalletService = inject(CryptoWalletService);
	const modalService = inject(ModalService);
	const infoService = inject(InfoService);
	const router = inject(Router);
	const translationService = inject(TranslationService);

	const walletId = activatedRouteSnapshot.queryParamMap.get("wallet_pid");
	const transactionId = activatedRouteSnapshot.queryParamMap.get("transaction_pid");

	cryptoWalletService.getTransaction(walletId, transactionId).subscribe({
		next: (tx) => {
			modalService
				.create(TransactionWrapperModalComponent, {
					transaction: tx,
					canOpen: true
				})
				.present();
			router.navigateByUrl("/my-account/history");
		},
		error: (error) => {
			infoService.setError(error || translationService.translate("dashboard_rewards_stake_error"));
			router.navigateByUrl("/my-account/history");
		}
	});

	return null;
};
